import * as React from 'react'

import { observer } from 'mobx-react'

import * as WeatherIcon from '~/client/src/shared/components/WeatherIcon'

import Colors from '~/client/src/shared/theme.module.scss'

interface IProps {
  openWeatherIconCode: string
  className?: string
  size?: number

  /**
   * If true, use colored icons, otherwise use monochrome (currentColor)
   */
  isColor?: boolean
}

type IconsMapAndColors = {
  [key: string]: [(props: any) => JSX.Element, string]
}

// Map of OpenWeather icon codes to icon components and their colors as provided by design
const iconsMap: IconsMapAndColors = {
  '01d': [WeatherIcon.Sunny, Colors.secondary50],
  '02d': [WeatherIcon.PartlyCloudy, Colors.secondary50],
  '03d': [WeatherIcon.Cloudy, Colors.neutral50],
  '04d': [WeatherIcon.Cloudy, Colors.neutral50],
  '09d': [WeatherIcon.Rain, Colors.primary60],
  '10d': [WeatherIcon.Shower, Colors.primary60],
  '11d': [WeatherIcon.Thunderstorm, Colors.primary60],
  '13d': [WeatherIcon.Snow, Colors.primary70],
  '50d': [WeatherIcon.Fog, Colors.neutral50],
  '01n': [WeatherIcon.ClearNight, Colors.primary20],
  '02n': [WeatherIcon.PartlyCloudyNight, Colors.primary20],
  '03n': [WeatherIcon.Cloudy, Colors.neutral50],
  '04n': [WeatherIcon.Cloudy, Colors.neutral50],
  '09n': [WeatherIcon.Rain, Colors.primary60],
  '10n': [WeatherIcon.Shower, Colors.primary60],
  '11n': [WeatherIcon.Thunderstorm, Colors.primary60],
  '13n': [WeatherIcon.Snow, Colors.primary70],
  '50n': [WeatherIcon.Fog, Colors.neutral50],
}

@observer
export default class OpenWeatherIcon extends React.Component<IProps> {
  public render() {
    const { openWeatherIconCode, className, isColor } = this.props
    if (!openWeatherIconCode || !iconsMap[openWeatherIconCode]) {
      return null
    }

    const iconRenderer: (props: any) => JSX.Element =
      iconsMap[openWeatherIconCode][0]

    if (!iconRenderer) {
      return null
    }

    if (isColor) {
      const color = iconsMap[openWeatherIconCode][1]
      return iconRenderer({ className, color })
    }

    return iconRenderer({ className })
  }
}
